export type GridState = "importing" | "exporting";

/**
 * Human-readable labels for grid states
 */
export const gridStateLabels: Record<GridState, string> = {
  importing: "Importing",
  exporting: "Exporting",
} as const;

/**
 * Get human-readable label for a grid state
 */
export function getGridStateLabel(state: GridState): string {
  return gridStateLabels[state];
}
